<template>
  <div class="badgeUploader">
    <v-file-input
      v-on:change="fileSelected"
      v-model="files"
      label="Badge Upload"
    ></v-file-input>

    <v-btn class="default-action-btn" v-on:click="submitFiles">Upload</v-btn>
  </div>
</template>

<script>
import unzip from "unzip-js"
import streamToBlob from "stream-to-blob"

import { BadgesAPI } from "@/lib/api"
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  name: "BadgeUpload",
  data() {
    return {
      file: {},
      files: []
    }
  },
  methods: {
    fileSelected(File) {
      this.file = File
    },
    submitFiles() {
      if (this.file.type == "application/zip") {
        unzip(this.file, (err, zipFile) => {
          zipFile.readEntries((err, entries) => {
            if (err) {
              return console.error(err)
            }

            entries.forEach(entry => {
              if (
                !entry.name.includes("__MACOSX") &&
                !entry.name.endsWith(".DS_Store") &&
                !entry.name.endsWith("/")
              ) {
                zipFile.readEntryData(entry, false, (err, readStream) => {
                  if (err) {
                    return console.error(err)
                  }

                  streamToBlob(readStream).then(blob => {
                    blob["name"] = entry.name
                    BadgesAPI.create(blob).then(() => {
                      this.fireEvent("badge:create")
                      this.file = {}
                      this.files = []
                    })
                  })
                })
              }
            })
          })
        })
      } else {
        BadgesAPI.create(this.file).then(() => {
          this.fireEvent("badge:create")
          this.file = {}
          this.files = []
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/variables";
@import "../../scss/buttons";
</style>
